import { render, staticRenderFns } from "./AdminUserDetail.vue?vue&type=template&id=2ec83952&scoped=true"
import script from "./AdminUserDetail.vue?vue&type=script&lang=js"
export * from "./AdminUserDetail.vue?vue&type=script&lang=js"
import style0 from "./AdminUserDetail.vue?vue&type=style&index=0&id=2ec83952&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec83952",
  null
  
)

export default component.exports